// v-reveal — scroll-triggered entrance. Adds the .reveal class up front and
// .revealed once the element enters the viewport (one-shot). Optional value
// is a stagger delay in ms: v-reveal="120". Reduced-motion users see content
// immediately (base.scss neutralizes the transition).
import type { Directive } from 'vue'

let observer: IntersectionObserver | null = null

function getObserver(): IntersectionObserver {
    if (!observer) {
        observer = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('revealed')
                        observer?.unobserve(entry.target)
                    }
                }
            },
            { threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
        )
    }
    return observer
}

export const vReveal: Directive<HTMLElement, number | undefined> = {
    mounted(el, binding) {
        // Fail open: no observer support -> content simply shows.
        if (typeof IntersectionObserver === 'undefined') return
        el.classList.add('reveal')
        if (binding.value) {
            el.style.setProperty('--reveal-delay', `${binding.value}ms`)
        }
        getObserver().observe(el)
    },
    beforeUnmount(el) {
        observer?.unobserve(el)
    },
}
